import type { CatchWeatherSnapshot } from '../../types/api';
import { weatherCodeLabel, weatherCodeEmoji } from '../spots/weatherCode';

export function CatchWeatherCard({ weather }: { weather: CatchWeatherSnapshot }) {
  const rows: Array<[string, string]> = [
    ['Feels like', `${Math.round(weather.apparentTempF)}°F`],
    ['Wind', `${Math.round(weather.windSpeedMph)} mph (gusts ${Math.round(weather.windGustsMph)})`],
    ['Pressure', `${Math.round(weather.pressureHpa)} hPa`],
    ['Humidity', `${weather.humidityPct}%`],
    ['Cloud cover', `${weather.cloudCoverPct}%`],
    ['Precipitation', `${weather.precipitation.toFixed(2)} in`],
  ];

  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-5 shadow-sm space-y-3">
      <div className="flex items-center gap-3">
        <span className="text-4xl" aria-hidden>{weatherCodeEmoji(weather.weatherCode, weather.isDay)}</span>
        <div>
          <p className="text-2xl font-bold text-slate-900 dark:text-slate-50">{Math.round(weather.temperatureF)}°F</p>
          <p className="text-sm text-slate-500 dark:text-slate-400">{weatherCodeLabel(weather.weatherCode)}</p>
        </div>
      </div>
      <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
        {rows.map(([label, value]) => (
          <div key={label} className="flex justify-between">
            <dt className="text-slate-500 dark:text-slate-400">{label}</dt>
            <dd className="text-slate-800 dark:text-slate-200 font-medium">{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
